Vue.component('userTeamProfile', {
    template: templates.userTeamProfile,
    props: ['team', 'show'],
    data() {
        return {
          // Add any local data properties here
        }
    },
    mounted() {
        const c = this;

    },
    watch: {
        team: function() {
            const c = this;
        }
    },
    methods: {
        format(time) {
            // Hours, minutes and seconds
            var hrs = ~~(time / 3600);
            var mins = ~~((time % 3600) / 60);
            var secs = ~~time % 60;

            // Output like "1:01" or "4:03:59" or "123:03:59"
            var ret = "";
            if (hrs > 0) {
                ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
            }
            ret += "" + mins + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;
            return ret;
        },
        flip(id) {
            // if (id) {
            // const c = this;
            
            // const $card = $(`[data-id="${id}"] .playing-card:visible`);
            // //$card.addClass('playing-card--flipped');

            // // if($card.hasClass('flipped')) {
            // //   $card.addClass('unflip');
            // //   setTimeout(function(){
            // //     $card.removeClass('flipped').removeClass('unflip');
            // //   }, 500);
            // // }
            // // else { 
            //     $card.addClass('flipped');
            // // }
            // }
        },
        select(team) {
            //card.selected = card.selected ? false : true;
        }
    }


})